export const messages = {
  title: '备忘录',
  newMemo: '新增',
  cancel: '取消',
  add: '添加',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  clear: '清除',
  loading: '加载中…',
  titlePlaceholder: '标题（可选）',
  contentPlaceholder: '内容',
  dueLabel: 'DDL',
  dueFormatHint: 'DDL 格式应为 20260716',
  overdue: '已逾期',
  dragHint: '拖拽调整顺序',
  noMemos: '还没有备忘录',
  noMemosDescription: '点击「新增」按钮创建你的第一条备忘录',
  newMemoAction: '+ 新增备忘录',
  addSuccess: '已添加',
  addFailed: '添加失败',
  updateSuccess: '已更新',
  updateFailed: '更新失败',
  moveToTrashHint: '删除后将移入回收站',
  movedToTrash: '已移入回收站',
  trash: '回收站',
  trashEmpty: '回收站是空的',
  untitled: '无标题',
  deletedAt: '删除于 {time}',
  restore: '恢复',
  restoreSuccess: '已恢复',
  restoreFailed: '恢复失败',
  purge: '彻底删除',
  purgeConfirmTitle: '彻底删除',
  purgeConfirmMessage: '「{title}」将被永久删除，此操作不可恢复。确定吗？',
  purgeSuccess: '已彻底删除',
  purgeFailed: '删除失败',
  emptyTrash: '清空回收站',
  emptyTrashConfirmTitle: '清空回收站',
  emptyTrashConfirmMessage: '回收站中的 {count} 条备忘录将被永久删除，此操作不可恢复。确定吗？',
  emptyTrashSuccess: '已清空回收站',
  emptyTrashFailed: '清空失败',
  loadFailed: '加载失败'
} as const
